import { EMAIL_TEMPLATE_STATUS } from '../constants/emailConstants';

export const FILTER_STATUS_OPTIONS = [
  {
    value: '',
    label: 'All Status',
  },
  {
    value: EMAIL_TEMPLATE_STATUS.ACTIVE,
    label: 'Active',
  },
  {
    value: EMAIL_TEMPLATE_STATUS.INACTIVE,
    label: 'Inactive',
  },
  {
    value: EMAIL_TEMPLATE_STATUS.DRAFT,
    label: 'Draft',
  },
];

export const FILTER_DEFAULT_OPTIONS = [
  {
    value: '',
    label: 'All Templates',
  },
  {
    value: 'true',
    label: 'Default Only',
  },
  {
    value: 'false',
    label: 'Non-Default',
  },
];

export const FILTER_LABELS = {
  SEARCH: 'Search templates...',
  TYPE: 'All Types',
  STATUS: 'All Status',
  DEFAULT: 'All Templates',
  CLEAR: 'Clear',
};

export const RESPONSIVE_BREAKPOINTS = {
  MOBILE: '768px',
  TABLET: '1024px',
  DESKTOP: '1200px',
};
